import { Button, Container, FormControl, Grid, InputLabel, NativeSelect, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React from 'react'
import { ABI, API_URL, bsccontractaddress, Bsc_Chainid, ethcontractaddress, ETH_Chainid, maticcontractaddress, Matic_Chainid } from '../../Config';
import swal from "sweetalert";
import { useWeb3React } from '@web3-react/core';
import { useHistory } from 'react-router-dom';
import { useCheckChain } from '../../Hooks/useCheckChain';
import Loading from "../../Components/loader/loader";
import { useState } from 'react'; 

const FirstForm = () => {
    const { account, library } = useWeb3React();
    const history = useHistory();
    const { switchChain } = useCheckChain();
    const [isloading, setisloading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const Token_Name = e.target.tokenname.value;
        const Token_address = e.target.tokenaddress.value;
        const currency = e.target.currency.value;
        const tokenbuy = e.target.tokenbuy.value;
        let contract_address;
       
       if (library) {

        if(Token_Name!="" && Token_address !="" && tokenbuy!="" && currency!="" ){

            const Web3 = require('web3');
            const web3 = new Web3(library.provider)
            let iswebaddress = web3.utils.isAddress(Token_address);
            if(iswebaddress==true){

            if (currency == "BNB") {
                contract_address = bsccontractaddress;
                await switchChain(Bsc_Chainid)
            } else if (currency == "MATIC") {
                contract_address = maticcontractaddress
                await switchChain(Matic_Chainid)
            }else if(currency == "ETH"){
                contract_address = ethcontractaddress
                await switchChain(ETH_Chainid)
            }
            
            setisloading(true);
            const Contract = new web3.eth.Contract(ABI, contract_address)
           
            Contract.methods.addCurrenicies(Token_address).send({ from: account }).then(async () => {
                var data = new FormData();
                data.append("token_name", Token_Name);
                data.append("token_address", Token_address);
                data.append("currency", currency);
                data.append("address", account);
                data.append("Tokenbuy",tokenbuy);
                data.append("type", "Insertdata");

                await axios.post(`${API_URL}/TokenApi.php`, data, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then((result) => {
                    console.log(result,"result");
                    setisloading(false);
                    swal({
                        title: "Success",
                        text: "Congratulations! You successfully add Token",
                        icon: "success",
                        allowOutsideClick: false,
                        confirmButtonText: 'ok',
                        confirmButtonColor: '#2dbe60',
                    }).then(() => {
                        history.push('/Myitem');
                    })
                })

            }).catch(() => {
                setisloading(false);
                swal({
                    title: "Warning",
                    text: "Something Went Wrong",
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: 'ok',
                    confirmButtonColor: '#2dbe60',
                })
            })

            }else{
                setisloading(false);
                swal({
                    icon: "error",
                    text: 'Not an ethereum address',
                    title: "error",
                    allowOutsideClick: false,
                    confirmButtonText: 'ok',
                    confirmButtonColor: '#2dbe60',
                })
            }

        }else{
            swal({
                title: "Warning",
                text: "Please fill all the details",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',
            })
        }
        } else {
            swal({
                title: "Warning",
                text: "Please Connect your wallet first",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',
            })
        }
    }

    const checkcurrency = (e) => {
        let currency = e.target.value;
       
        if (currency == "BNB") {
            switchChain(Bsc_Chainid)
        } else if (currency == "MATIC") {
            switchChain(Matic_Chainid)
        }else if (currency == "ETH"){
            switchChain(ETH_Chainid)
        }

    }

    return (
        <div>
           
           <Container maxWidth='lg' component='form' method='post' onSubmit={handleSubmit} >
                <Grid container spacing={2} className='fom_det'>
                    <Grid item lg={12} sm={12} md={12} xs={12}>
                        <Typography variant='h5' fontWeight='600' fontSize='25px'> Fill Token Details </Typography>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label className='add_n'>Token Name</label>
                        <br></br>
                        <TextField id="outlined-basic" name='tokenname' fullWidth />
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label className='add_n'>Token Address</label>
                        <TextField id="outlined-basic" name='tokenaddress' fullWidth />
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label className='add_n'>User Address</label>
                        <TextField id="outlined-basic" value={account} name='useraddress' fullWidth />
                    </Grid>
                
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <FormControl fullWidth className='Currency'>
                            <label className=''>Currency</label>
                            <InputLabel variant="standard" htmlFor="uncontrolled-native">
                            </InputLabel>
                            <NativeSelect defaultValue="BNB" name="currency" onChange={checkcurrency}>
                                <option value="BNB" >BNB</option>
                                <option value="MATIC" >MATIC</option>
                                <option value="ETH" >ETH</option>
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item lg={12} sm={12} md={12} xs={12}>
                        <label className='add_n'> Token Buy URL</label>
                        <TextField id="outlined-basic"  name='tokenbuy' fullWidth />
                    </Grid>

                    <Grid item lg={12} sm={12} md={12} xs={12}>
                        <Button variant='contained' type="submit">Submit</Button>
                    </Grid>
                </Grid>
            </Container>
            {isloading && <Loading props={'Transaction in process, Please wait do not refresh the page...'} />}
    
        </div>
    )
}

export default FirstForm;